import { Box, Checkbox } from '@factorialco/deprecated-design-system'
import { FormikProps, FormikProvider } from 'formik'
import { AtsQuestionTypeEnumValues } from 'generated/resources/datatable.graphql'
import { AtsQuestionOptionInput, AtsQuestionTypeEnum } from 'generated/resources/graphql'

import Select from 'modules/core/components/Select'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { getQuestionTypeLabel, questionTypeHasOptions } from 'modules/ats/lib/utils/customQuestion'

import { OptionsField } from './OptionsField'
import { CreateQuestionFormValues } from './QuestionFormValues'

interface Props {
  form: FormikProps<CreateQuestionFormValues>
  templateFeatureEnabled?: boolean
  saveAsTemplate?: boolean
  setSaveAsTemplate?: (value: boolean) => void
}

export const CreateQuestionForm = ({
  form,
  templateFeatureEnabled,
  saveAsTemplate,
  setSaveAsTemplate,
}: Props) => {
  const defaultOptions: AtsQuestionOptionInput[] = [{ text: '' }, { text: '' }]
  const hasOptions = form.values.questionType
    ? questionTypeHasOptions(form.values.questionType)
    : false

  return (
    <FormikProvider value={form}>
      <Box gap="s16">
        <TextField
          label={i18n.t(
            'ats.job_posting_settings.application_form.custom_questions.question_label'
          )}
          value={form.values.label}
          onChange={(label) => {
            form.setFieldValue('label', label, false)
          }}
          error={form.errors.label}
        />

        <Select
          label={i18n.t('ats.job_posting_settings.application_form.custom_questions.question_type')}
          value={form.values.questionType}
          options={AtsQuestionTypeEnumValues.map((type) => ({
            label: getQuestionTypeLabel(type),
            value: type,
          }))}
          showOriginalLabelText
          onChange={(value) => {
            // eslint-disable-next-line no-type-assertion/no-type-assertion -- The onChange is typed as "string", not much we can do
            const questionType = value as AtsQuestionTypeEnum
            const addDefaultOption =
              questionTypeHasOptions(questionType) && form.values.options?.length === 0

            form.setValues(
              {
                ...form.values,
                questionType,
                options: addDefaultOption ? defaultOptions : form.values.options,
              },
              false
            )
          }}
        />

        {hasOptions && <OptionsField form={form} />}

        <Checkbox
          label={i18n.t('ats.questions.mandatory')}
          checked={form.values.mandatory ?? false}
          onChange={(event) => {
            form.setFieldValue('mandatory', event.target.checked, false)
          }}
        />

        {templateFeatureEnabled && (
          <Checkbox
            label={i18n.t('ats.questions.save_as_template')}
            checked={saveAsTemplate}
            onChange={(event) => setSaveAsTemplate?.(event.target.checked)}
          />
        )}

        {hasOptions && (
          <Checkbox
            label={i18n.t(
              'ats.job_posting_settings.application_form.custom_questions.auto_disqualify'
            )}
            checked={form.values.autoDisqualify ?? false}
            onChange={(event) => form.setFieldValue('autoDisqualify', event.target.checked, false)}
          />
        )}
      </Box>
    </FormikProvider>
  )
}
